import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'src/app/services/message.service';
import { Router } from '@angular/router';
declare const bootstrap: any;

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})
export class OtpComponent implements OnDestroy, AfterViewInit {
  OtpForm: FormGroup;
  value: any;
  mailId: any;
  fieldTouched!: boolean;
  constructor(
    private commonService: CommonService,
    private _fb: FormBuilder,
    private message: MessageService,
    private router: Router
  ) {
    var Email = localStorage.getItem('userMailID');
    this.value = JSON.parse(Email!);
    this.mailId = this.value.userMailID;
    this.OtpForm = this._fb.group({
      OTP: ['', [Validators.required]],
    });
  }
  ngAfterViewInit() {
    this.startCarouselManual();
  }
  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
    localStorage.removeItem('userMailID');
  }
  ChangemailId() {
    this.router.navigate(['/forgetpassword']);
  }
  ResendOTP() {
    let requestBody = {
      userMailID: this.mailId,
    };
    localStorage.setItem('userMailID', JSON.stringify(requestBody));

    this.commonService.sendOTP(requestBody).subscribe((res: any) => {
      if (res.data) {
        this.message.successToast('Code send Successfully');
      } else {
        this.message.errorToast(res.errorMessage);
      }
    });
  }
  OTPSend() {
    if (this.OtpForm.invalid) {
      this.OtpForm.markAllAsTouched();
      this.message.errorToast('Please fill all required fields');
    } else {
      if (localStorage.getItem('userMailID')) {
        var Email = localStorage.getItem('userMailID');
        var emaildt = JSON.parse(Email!);
        let requestBody = {
          email: emaildt.userMailID,
          otp: this.OtpForm.value.OTP,
        };

        this.commonService.VerifyOTP(requestBody).subscribe((res: any) => {
          if (res.data) {
            this.fieldTouched = false;
            this.message.successToast('New password has shared on the mail id');
            this.router.navigate(['/login']);
          } else {
            this.message.errorToast(res.errorMessage);
          }
        });
      } else {
        this.message.errorToast('No Email found');
      }
    }
  }

  startCarouselManual() {
    setTimeout(() => {
      var myCarousel = document.querySelector('#carouselExampleControls2');
      var carousel = new bootstrap.Carousel(myCarousel, {
        interval: 4000,
        wrap: true,
        touch: false,
        keyboard: false,
      });
    }, 0);
  }
}
